import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../api/client.js';

/**
 * Anmeldezustand für die ganze App.
 *
 * Der Zustand wird beim Start einmal vom Server geholt — die Session liegt in
 * einem HttpOnly-Cookie, das JavaScript bewusst nicht lesen kann.
 */
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [geladen, setGeladen] = useState(false);

  const laden = useCallback(async () => {
    try {
      const d = await api.auth.me();
      setUser(d.user);
    } catch {
      setUser(null);
    } finally {
      setGeladen(true);
    }
  }, []);

  useEffect(() => { laden(); }, [laden]);

  const wert = {
    user,
    geladen,
    neuLaden: laden,
    login: async (email, passwort) => {
      const d = await api.auth.login(email, passwort);
      setUser(d.user);
      return d.user;
    },
    register: async (email, passwort, name) => {
      const d = await api.auth.register(email, passwort, name);
      setUser(d.user);
      return d.user;
    },
    logout: async () => {
      await api.auth.logout();
      setUser(null);
    },
  };

  return <AuthContext.Provider value={wert}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth muss innerhalb von AuthProvider verwendet werden');
  }
  return ctx;
}
